import React from 'react';

interface SwitchButtonProps {
  check: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  checkLabel?: string;
  unCheckLabel?: string;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const CommonSwitchButton = (props: SwitchButtonProps) => {
  const { check, onChange, id, checkLabel, unCheckLabel, disabled, size = 'large' } = props;

  return (
    <label htmlFor={id} className={`commonSwitchBtn switch-product ${size}`}>
      <input disabled={disabled} type="checkbox" id={id} checked={check} onChange={onChange} />
      <span className="txt-check unchecked">{unCheckLabel || '접힘'}</span>
      <span className="txt-check checked">{checkLabel || '펼침'}</span>
      <span className="ico-check"></span>
    </label>
  );
};

export default CommonSwitchButton;
